import {
  SELECT,
  LIKE_UNLIKE,
  TO_ADD,
  SELECTED_TRACK,
  RESET_SELECTED,
} from "../types";
import { auth, firestore } from "../../firebase";
import { Track, TComment } from "../../models/track";
import { Dispatch } from "redux";

export const selectTrack = (track: Track) =>
  (dispatch: Dispatch) => {
    // history.pushState({}, )
    dispatch({
      type: SELECT,
      payload: track,
    });
  };

export const likeSong = (id: string) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: LIKE_UNLIKE,
      payload: id,
    });
  };

export const toAdd = (selected: Track) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: TO_ADD,
      payload: selected,
    });
  };

export const selectedTrack = (selected: Track) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: SELECTED_TRACK,
      payload: selected,
    });
  };

export const resetSelected = () =>
  (dispatch: Dispatch) => {
    dispatch({
      type: RESET_SELECTED,
    });
  };

export const userPlayed = (id: string) => {
  let user = auth.currentUser;
  if (user === null || user === undefined) return null;
  let a = localStorage.getItem("TrHcetiH1p");
  if (a) {
    let played = JSON.parse(a);
    if (played !== null && played !== undefined) {
      return played.includes(id);
    }
  }
};

export const addComment = async (comment: TComment) => {
  try {
    if (
      !comment.tid ||
      !comment.body ||
      !comment.user.id ||
      !comment.user.username
    ) {
      return false;
    }
    let doc = (
      await firestore.collection("comments").doc(comment.tid).get()
    ).data();
    if (!doc) {
      await firestore
        .collection("comments")
        .doc(comment.tid)
        .set({ comments: [comment] });
    } else {
      let comments = [...doc.comments, comment];
      await firestore.collection("comments").doc(comment.tid).set({ comments });
    }

    return true;
  } catch (error) {
    return false;
  }
};

export const deleteComment = async (
  id: string | undefined,
  cid: string,
): Promise<boolean> => {
  if (!id) return false;
  try {
    let data = (await firestore.collection("comments").doc(id).get()).data();
    if (data) {
      let comments = data.comments.filter((comment: any) => comment.id !== cid);
      await firestore.collection("comments").doc(id).set({ comments });
    }

    return true;
  } catch (error) {
    return false;
  }
};
